//TODO: TEST!
(function (upp, document, window, $, Snap) {
    'use strict';

    var snapper;

    upp.directive('mainBody', ['config',
        function (config) {
            var $window,
                $document,
                $container,
                $leftMenu;

            var toggleSideNav = function (snapper, side) {
                return function () {
                    if (snapper.state().state === side) {
                        snapper.close();
                    } else {
                        snapper.open(side);
                    }
                }
            };

            return {
                restrict: 'C',
                priority: 1,
                controller: ['$scope', '$element', '$rootScope', 'translator', '$location', '$q',
                    function ($scope, $element, $rootScope, translator, $location, $q) {

                        /**
                         * Changes the text of a module in the main navbar
                         *
                         * @method changeNavText
                         *
                         * @param module
                         * @param htmlText
                         * @param left
                         */
                        $rootScope.changeNavText = function (module, htmlText, left) {
                            if (module) {
                                var $moduleElto = $element.find('[data-mod-key="' + module.toUpperCase() + '"] .nav-opt-link'),
                                    side;

                                if (left) {
                                    side = "left";
                                } else {
                                    side = "right";
                                }
                                $moduleElto.removeClass('eshop-has-content');
                                if (htmlText) {
                                    $moduleElto.attr("data-upp-" + module + '-' + side, htmlText);
                                    $moduleElto.addClass('eshop-has-content');
                                }
                            } else {
                                throw new Error("no module neither text to show");
                            }
                        };

                        /**
                         * Changes the name of the actual option in the top navbar in mobile, set 'active' class in the navbar, ...
                         *
                         * @method changeActualOption
                         */
                        $rootScope.changeActualOption = (function () {
                            var toggleLeft = function () {
                                    toggleSideNav(snapper, 'left')();
                                },
                                clickFunction = toggleLeft,
                                $navbarMain,
                                $htmlElement,
                                $actualOption = $element.find('#navbar-mobile-top-current-section'),
                                $backIcon = $element.find('#navbar-mobile-top-back');

                            var redirectToUrl = function (url) {
                                $location.path(url);
                                $rootScope.$apply();
                            };

                            var prepareActualOptionText = function (textOptions) {
                                var deferred = $q.defer(),
                                    key;

                                if (key = textOptions.i18n) {
                                    deferred.resolve(translator.i18n(key));
                                } else if (key = textOptions.moduleKey2Display) {
                                    return config.getModuleDisplayText(key);
                                } else if (key = textOptions.text) {
                                    deferred.resolve(key);
                                }
                                return deferred.promise;
                            };

                            var addUppHomeClass = function (add) {
                                $htmlElement = $htmlElement || $('html');

                                if (add) {
                                    $htmlElement.addClass('upp-home');
                                } else {
                                    $htmlElement.removeClass('upp-home');
                                }
                            };

                            $actualOption.unbind('click').bind('click', function () {
                                clickFunction && clickFunction();
                            });
                            $backIcon.unbind('click').bind('click', function () {
                                clickFunction && clickFunction();
                            });

                            /**
                             * Changes the name of the actual option in the top navbar in mobile, set 'active' class in the navbar, ...
                             *
                             * @param {Object} textOptions. Properties to prepare the text to show in the menu:
                             *                          * If 'i18n' prop given, the text is translated
                             *                          * If 'moduleKey2Display' prop given, the text is given by the config service
                             *                          * Else, the own text is displayed
                             * @param {*} backNavigation *optional.
                             *            If given as a String, url where button should redirect,.
                             *            If given as a Function the function is fired.
                             *            If not setted, should open navbar.
                             */
                            return function (textOptions, backNavigation) {
                                var navbarKey;

                                if (textOptions) {
                                    // Show/hide 'back'/'3 lines' icons in the top navbar in mobile devices, and set the behaviour
                                    if (backNavigation) {
                                        clickFunction = function () {
                                            if (typeof backNavigation === 'function') {
                                                backNavigation();
                                            } else {
                                                redirectToUrl(backNavigation);
                                            }
                                        };
                                        $leftMenu.hide();
                                        $backIcon.show();
                                    } else {
                                        clickFunction = toggleLeft;
                                        $backIcon.hide();
                                        $leftMenu.show();
                                    }

                                    if (navbarKey = textOptions.navbarKey) {

                                        //set css class 'active' to the actual option in the navbar, and remove the former one
                                        $navbarMain = $navbarMain || $element.find('#navbar-main');

                                        $navbarMain.find('.nav-opt[data-navbar-key]').removeClass('active');
                                        $navbarMain.find('.nav-opt[data-navbar-key="' + navbarKey + '"]').addClass('active');


                                        // set/remove css class 'upp-home' to the html element
                                        addUppHomeClass(navbarKey === 'home');
                                    } else {
                                        addUppHomeClass(false);
                                    }

                                    //Set 'actual option' text in the top navbar in mobile devices, with given parameters
                                    prepareActualOptionText(textOptions)
                                        .then(function (text) {
                                            $actualOption.text(text)
                                        });

                                } else {
                                    throw new Error("no name given");
                                }
                            }

                        })();
                    }],


                link: function (scope, element) {
                    var resizeTimer,
                    $window = $(window);
                    $document = $(document);
                    $container = $('#main-container')[0];
                    $leftMenu = element.find('#navbar-mobile-top-left-icon');

                    config.getTemplateCssPath().then((templateCssUrl) => {
                        const tag = 'link';
                        const id = 'templateCss';
                        let templateCssElem = document.querySelector(`${tag}#${id}`);
                        if (!templateCssElem) {
                            templateCssElem = document.createElement(tag);
                            templateCssElem.setAttribute('id', id);
                            templateCssElem.setAttribute('rel', 'stylesheet');
                            templateCssElem.setAttribute('type', 'text/css');
                            document.head.appendChild(templateCssElem);
                        }
                        templateCssElem.setAttribute('href', templateCssUrl);
                    });

                    //https://github.com/jakiestfu/Snap.js/
                    snapper = new Snap({
                        element: $container,
                        maxPosition: 200,
                        minPosition: -200,
                        flickThreshold: 100,
                        minDragDistance: 10
                    });

                    var checkWidthForNavbarSnapper = function () {
                        var ASIDE_NAVBAR_MAX_WIDTH = 979;
                        if ($window.width() > ASIDE_NAVBAR_MAX_WIDTH) {
                            snapper.disable();
                        } else {
                            snapper.enable();
                        }
                    };

                    $window.resize(function () {
                        clearTimeout(resizeTimer);
                        resizeTimer = setTimeout(checkWidthForNavbarSnapper, 100);
                    });

                    checkWidthForNavbarSnapper();
                    //If the nav bar menu is in responsive mode and opened (showing options), when user clicks on some menu options (those with attribute [data-menu-toggleable="S"]), the menu is closed
                    var closeSideNav = function (snapper) {
                        return function () {
                            snapper.close();
                        }
                    };
                    $document.on('click', '[data-menu-toggleable="S"]', closeSideNav(snapper));

                    scope.snapLeft = toggleSideNav(snapper, 'left');
                    scope.snapRight =  toggleSideNav(snapper, 'right');
                }
            }
        }]);

    upp.directive('sideNavbarTpl', ['config',
        function (config) {
            return {
                restrict: 'E',
                priority: 2,
                templateUrl: require('../templates/navbar.html'),
                replace: true,
                link: function (scope, element) {
                    var _forEach = angular.forEach,
                        $optionsIcon = $('#navbar-mobile-top-right-icon');

                    config.shouldShowAccount().then(function (show) {
                        if (!show) {
                            $optionsIcon.remove();
                            snapper && snapper.settings({disable: 'right'});
                        }
                    });

                    config.getLeftActiveModules()
                        .then(function (activeModules) {
                            _forEach(activeModules, function (module) {
                                if (module.name && module.display) {
                                    var $moduleLi = element.find('[data-mod-key=' + module.name + ']');
                                    $moduleLi.addClass('mod-active');
                                    $moduleLi.find('.nav-opt-link').text(module.display);
                                }
                            });
                        });
                }
            }
        }]);

    upp.directive('adBannerTpl',
        function () {
            var $htmlElto,
                adType,
                adProvider,
                adHeight,
                $content = $('#content'),
                $ad;

            var _addGlobalCssClasses = function () {
                $htmlElto.addClass('upp-ad').addClass('upp-ad-' + adType);
            };

            var _removeGlobalCssClasses = function () {
                $htmlElto.removeClass('upp-ad').removeClass('upp-ad-' + adType);
            };

            var _modifySizes = function (size) {
                $ad = $ad || $('#ad');
                if ($ad.length) {
                    $content.css('margin-bottom', size ? size + 'px' : '0');
                    $ad.css('height', size ? (parseInt(size) + 5) + 'px' : '0');
                }
            };

            var _getBannerHtml = function () {
                return '' +
                    '<div id="ad">' +
                    '   <a href="http://www.upplication.com">' +
                    '       <img src="img/banner_ad.png" alt="Ad" />' +
                    '   </a>' +
                    '</div>';
            };

            var enableAds = function () {
                if (adType) {
                    _addGlobalCssClasses();
                    _modifySizes(adHeight);
                }
            };

            var disableAds = function () {
                if (adType) {
                    _removeGlobalCssClasses();
                    _modifySizes();
                }
            };

            return {
                restrict: 'E',
                controller: ['$scope', '$element', '$rootScope', 'config',
                    function ($scope, $element, $rootScope, config) {
                        $htmlElto = $('html');
                        $rootScope.enableAds = enableAds;
                        $rootScope.disableAds = disableAds;
                        config.getAdProps()
                            .then(function (ad) {
                                if (ad) {
                                    var _type = ad.name;
                                    if (_type === 'desktop' || _type === 'phone' || _type === 'tablet') {
                                        adType = ad.name;
                                        //adHeight = ad.heigth;
                                        adHeight = 50;
                                        adProvider = 'mopub';
                                        $element.replaceWith(_getBannerHtml(ad));
                                    }
                                }
                            });
                    }
                ]
            }
        });

})(upp, document, window, jQuery, Snap);



// WEBPACK FOOTER //
// ./src/app/common/directives/main_content_wrapper-directive.js